import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { AdminGroupListItem } from '@modules/groups-of-admins/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  GROUPS_OF_ADMINS_LIST_API_URL,
  GROUPS_OF_ADMINS_LIST_QUERY_KEY,
  GROUPS_OF_ADMINS_PERMISSIONS,
} from '@modules/groups-of-admins/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useGroupsOfAdminsListQuery(tableState: Ref<ITableState>): IContextQueryResult<
  ITableDataResponse<AdminGroupListItem>,
  Error
> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<AdminGroupListItem>>({
    queryKey: [GROUPS_OF_ADMINS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<AdminGroupListItem>>(
      GROUPS_OF_ADMINS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: GROUPS_OF_ADMINS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
